import * as TheKitchen from '@inmoment/the-kitchen';
import { DropdownObject } from '@inmoment/the-kitchen';

export const returnDropdownMenuForInterface = (type: string, selected: any, isIdValue?: boolean): DropdownObject[] => {
  const filteredKitchen = Object.keys(TheKitchen).filter((item) => item.includes('Options'));

  const types = type.split('|').map((item) => item.trim());

  // Unions of strings
  if (types.every((type) => type.match(/'.+'|".+"/))) {
    return types
      .map((type) => type.slice(1, type.length - 1))
      .map((type, id) => ({
        title: type.toString(),
        id: isIdValue ? type.toString() : id.toString(),
        isSelected: isIdValue ? undefined : selected ? type === selected.title : false,
      }));
  }

  const filteredArray: string[] = [];
  types.forEach((type) => {
    filteredArray.push(...filteredKitchen.filter((item) => item === `_${type}Options`));
  });

  const finalArr = filteredArray.flatMap<unknown>((key) => TheKitchen[key as keyof typeof TheKitchen]);

  return finalArr
    .filter((item) => item !== '"')
    .map((item, id) => ({
      title: `${item}`,
      id: isIdValue ? `${item}` : `${id}`,
      isSelected: isIdValue ? undefined : selected ? item === selected.title : false,
    }));
};
